import { render } from "./PriceCreate.vue?vue&type=template&id=6fe6ebf7"
import script from "./PriceCreate.vue?vue&type=script&lang=js"
export * from "./PriceCreate.vue?vue&type=script&lang=js"
script.render = render

export default script